import { query, request } from '@/utils/request';
import { stringify } from 'qs';

const prefix = '';

// 拉取机构预算信息
export function pullBudgetIndicator(orgId) {
  return request(`/zlb/budget/operation/platform/pull-budget-info/${orgId}`);
}

// 根据机构id查询机构
export function getBudgetOrgByOrgId(orgId) {
  return request(`/zlb/budget/operation/platform/query-budget-org-org-id/${orgId}`);
}

// 修改预算单位映射信息
export function updateBudgetOrgMapping(params) {
  return request('/zlb/budget/operation/platform/update-budget-org', {
    method: 'post',
    data: params,
  });
}

// 拉取预算单位
export function pullBudgetOrgAction(params) {
  return request('/zlb/budget/operation/platform/pull-budget-org', {
    method: 'post',
    data: params,
  });
}

// 获取预算单位信息
export function getBudgetOrgInfoServer(params) {
  return request('/zlb/budget/operation/platform/query-budget-org', {
    method: 'post',
    data: params,
  });
}

// 获取预算单位信息
export function searchHistoryRecord(params) {
  return request('/zlb/budget/operation/platform/query-org-match-log', {
    method: 'post',
    data: params,
  });
}

// 下载
export function downloadOrgInfo(params) {
  return request('/zlb/budget/operation/platform/download', {
    method: 'post',
    data: params,
    responseType: 'blob',
  });
}

// 枚举：预算关联状态
export function getBudgetAssociationStatus(params) {
  return request('/api/user/enum/listCostControlStatusEnum', {
    params,
  });
}

// 枚举：预算匹配状态
export function getBudgetMatchStatus(params) {
  return request('/api/user/enum/listBudgetMatchStatusEnum', {
    params,
  });
}

// 枚举：一致性状态
export function getConsistencyState(params) {
  return request('/api/user/enum/listConsistencyCheckEnum', {
    params,
  });
}

// 批量导出单位
export function bulkExportUnit(params) {
  return request('/api/zlbuser/institution/downCheckResults', {
    responseType: 'blob',
    method: 'post',
    data: params,
  });
}

// 查询机构映射信息
export function queryBudgetOrgMapping(params) {
  return request('/zlb/budget/operation/platform/query-budget-org-detail', {
    method: 'post',
    data: params,
  });
}

// 查询未映射的预算单位信息
export function queryNotMappingBudgetOrgPage(params) {
  return request('/zlb/budget/operation/platform/query-budget-org-page', {
    method: 'post',
    data: params,
  });
}

/**
 *
 * 单位管理
 * @param {*} params
 * @returns
 *
 */

// 获取机构树接口
export function getInstitutionTree(params) {
  return request('/api/zlbuser/institution/operational/institution/tree', {
    params,
  });
}

// 分页查询机构下级单位列表
export function getInstitutionList(params) {
  return request(`/api/zlbuser/institution/tenant/institution/list?${stringify(params)}`);
}

// 获取指定机构下的单位管理员列表人员姓名精准搜索
export function getInstitutionOperator(params) {
  return request('/api/zlbuser/operational/institution/operator', {
    params,
  });
}

export function updateInstitutionStatus(params) {
  return request('/api/zlbuser/institution/operational/institution/status', {
    method: 'POST',
    data: params,
  });
}

export function updateFundPayStatus(params) {
  return request('/zlb/api/pay/config/batchEdit', {
    method: 'POST',
    data: params,
  });
}

export function getImportManagerTemplate(params = {}) {
  return request('/api/user/operational/importManager/template', {
    params,
  });
}

export function importUpload(data) {
  return request('/api/user/import/upload', {
    method: 'POST',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    data,
  });
}

export function updateOperational(params) {
  return request('/api/zlbuser/institution/operational/institution/update', {
    method: 'POST',
    data: params,
  });
}

export function importManagerRecord(params) {
  return request('/api/user/operational/importManager/record', {
    responseType: 'blob',
    params,
  });
}

export function updateOperationalStatus(params) {
  return request('/api/zlbuser/operational/institution/manager', {
    method: params.method || 'post',
    data: params,
  });
}

/**
 * 获取人员列表模版链接
 */
export async function getImportUnitTemplate(params) {
  return request(`/api/user/import/template?${stringify(params)}`);
}

// 下载失败记录文件
export async function downloadFailFile(params) {
  return request('/api/zlbuser/institution/import/record', {
    responseType: 'blob',
    params,
  });
}

// 预算指标列表（分页）
export function fetchBudgetList(data) {
  return request('/zlb/budget/operation/platform/budget-info-page', {
    method: 'POST',
    data,
  });
}

// 预算指标与报销场景关联
export function budgetReimburseRelation(data) {
  return request('/zlb/budget/operation/platform/budget-scenes-relation', {
    method: 'POST',
    data,
  });
}

// 根据预算id查询预算报销场景
export function queryBudgetSceneByBudgetId(id) {
  return request(`/zlb/budget/operation/platform/query-budget-scenes-budget-id/${id}`);
}

/**
 * 流程分页列表&流程类型名称模糊搜索
 */
export async function pageProcess(params) {
  return request('/workflow/baseInfo/pageProcess', {
    method: 'get',
    params,
  });
}

/**
 * 新增流程
 */
export async function newProcessModel(data) {
  return request('/workflow/processModel/newProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 复制流程
 */
export async function copyProcessModel(data) {
  return request('/workflow/processModel/copyProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 流程分页列表接口
 */
export async function pageProcessModel(data) {
  return request('/workflow/processModel/pageProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 校验空流程
 */
export async function checkEmptyProcess(params) {
  return request('/workflow/processModel/checkEmptyProcess', {
    method: 'get',
    params,
  });
}

/**
 * 上下架流程
 */
export async function changeStatus(data) {
  return request('/workflow/processModel/changeStatus', {
    method: 'post',
    data,
  });
}

/**
 * 分页获取机构或者部门下操作人员列表(非脱敏)
 *
 * @return
 * @param params
 */
export async function getInstitutionMember(params) {
  return request('/zlb/operation/organization/operatorInfo/list', {
    params,
  });
}

/**
 * 分页获取机构或者部门下操作人员列表(脱敏)
 *
 * @return
 * @param params
 */
export async function getInstitutionMemberDesensitization(params) {
  return request('/zlb/operation/organization/operator/list', {
    params,
  });
}

/**
 * 新增人员
 */
export async function addUser(data) {
  return request('/zlb/operation/createUser', {
    method: 'post',
    data,
  });
}

/**
 * 人员信息信息更新
 */
export async function updateUser(data) {
  return request('/zlb/operation/updateOperator', {
    method: 'post',
    data,
  });
}

/**
 * 查询操作人更多信息
 *
 * @return
 * @param params
 */
export async function getUserDetail(params) {
  return request('/zlb/operation/getUserDetail', {
    params,
  });
}

/**
 * 查询操作人更多信息(非脱敏)
 *
 * @return
 * @param params
 */
export async function getUserDetailInfo(params) {
  return request('/zlb/operation/getUserDetailInfo', {
    params,
  });
}

/**
 * 单位管理删除操作员身份
 */
export async function deleteOperatorAppointment(data) {
  return request('/zlb/operation/deleteOperator', {
    data,
    method: 'delete',
  });
}

/**
 * 单位管理批量删除操作员身份
 */
export async function batchDeleteOperator(data) {
  return request('/zlb/operation/batchDeleteOperator', {
    data,
    method: 'delete',
  });
}

/**
 * 查询操作员在机构部门下的所有任职
 * @param {*} params
 * @returns
 */
export async function queryAppointment(params) {
  return request('/zlb/operation/queryAppointment', {
    params,
  });
}

/**
 * 批量启用或停用用户接口
 */
export async function batchUpdateOperatorStatus(data) {
  return request('/zlb/operation/batchUpdateOperatorStatus', {
    data,
    method: 'post',
  });
}

/**
 * 单位管理批量调整部门接口
 */
export async function batchUpdateOperatorDept(data) {
  return request('/zlb/operation/batchUpdateOperatorDept', {
    data,
    method: 'post',
  });
}

/**
 * 单位管理获取用户所在机构下的部门树
 * @param {*} params
 * @returns
 */
export async function getTree(params) {
  return request('/zlb/operation/department/tree', {
    params,
  });
}

/**
 * 获取职级枚举集合
 * @returns
 */
export async function getOperatorRank() {
  return request(`${prefix}/api/user/dictionary/operator/rank`);
}

/**
 * 获取政治面貌枚举集合
 * @returns
 */
export async function getPoliticsstatus() {
  return request(`${prefix}/api/user/dictionary/politicsstatus`);
}

/**
 * 获取人员任职枚举集合
 * @returns
 */
export async function getPersonnelOffice() {
  return request(`${prefix}/api/user/dictionary/personnel/office`);
}

/**
 * 获取人员编制集合
 * @returns
 */
export async function getPersonnelForce() {
  return request(`${prefix}/api/user/dictionary/personnel/force`);
}

/*
 * 费控规则
 */
export async function queryCostControlRule(params) {
  return request(`/zlb/cost/control/standard/get-by-district/${params}`, {
    method: 'get',
  });
}

/**
 * 获取人员列表模版链接
 */
export async function getImportUserTemplate(params) {
  return request(`/api/user/import/template?${stringify(params)}`);
}

/**
 * 上传人员列表Excel
 */
export async function importUploadUser(data) {
  return request('/api/user/import/upload', {
    method: 'post',
    data,
  });
}

/**
 * 下载失败文件
 */
export async function importUserRecord(params) {
  return request('/api/user/import/user/record', {
    responseType: 'blob',
    params,
  });
}

// 标签类型和标签列表查询
export async function getTypeAndTagList(params) {
  return query('/api/zlbuser/tag/typeAndTagList', { params });
}

// 标签分类查询
export async function getTagTypeList(params) {
  return query('/api/zlbuser/tagtype/list', { params });
}

// 标签查询
export async function getTagList(params) {
  return query('/api/zlbuser/tag/list', { params });
}

// 划配置标签
export async function removeDomainTag(data) {
  return request('/api/zlbuser/tag/removeBillTag', {
    data,
    method: 'post',
  });
}

// 单位批量新增标签
export async function addDomainTag(data) {
  return request('/api/zlbuser/tag/addBillTag', {
    data,
    method: 'post',
  });
}

// 删除预算单位匹配关系
export function cancelOrgMatch(data) {
  return request('/zlb/budget/operation/platform/cancel-match', {
    data,
    method: 'POST',
  });
}

// 标签联合查询
export function getTagCombineList(params) {
  return request('/api/zlbuser/tag/tagCombineList', {
    params,
  });
}

// 批量导入人员操作-提交
export function importExcelCommit(data) {
  return request('/api/user/import/excel/commit', {
    data,
    method: 'POST',
  });
}

// 批量导入人员操作-查询
export function importExcelResult(serialCode) {
  return request(`/api/user/import/excel/result?serialCode=${serialCode}`);
}

export function institutionInfoModify(data) {
  return query('/zlb/operation/institution/info/modify', {
    data,
    method: 'POST',
  });
}

export function deleteInstitution(institutionId) {
  return query(`/api/zlbuser/institution/${institutionId}`, {
    method: 'DELETE',
  });
}

// 一键检测
export function institutionCheckHandler(data) {
  return request('/zlb/operation/ins/check/institutionCheck', {
    data,
    method: 'POST',
  });
}

// 一键检测结果查询
export function listInsCheckRecord(data) {
  return request('/zlb/operation/ins/check/listInsCheckRecord', {
    data,
    method: 'POST',
  });
}

// 一键检测删除
export function delInsCheckRecord(params) {
  return request('/zlb/operation/ins/check/delInsCheckRecord', {
    params,
  });
}

// 一键检测结果下载
export function insCheckResult(params) {
  return request('/zlb/operation/ins/check/download/insCheckResult', {
    params,
  });
}

/**
 * 获取机构的异常信息
 * @param {} data
 * @returns
 */
export function getInstitutionExceptionData(data) {
  return request('/zlb/operation/exception/record/num', {
    data,
    method: 'POST',
  });
}

/**
 * 查询部门树-租户平台使用
 */
export function getTenantInstitutionTree(params) {
  return query('/api/zlbuser/institution/tenant/department/tree', {
    params,
  });
}
